var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polygon, _polygon2, _path17, _path18, _circle, _polygon3, _rect44, _circle2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle3, _path33, _path34, _path35, _path36, _path37, _path38, _rect45, _rect46, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9ea829a-01ef-4860-a3a7-641ca853f294",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1082.19,
    height: 847.94,
    viewBox: "0 0 1082.19 847.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0bbd7947-ca61-424a-a753-fb567ef3345a",
    x1: 276.42,
    y1: 818,
    x2: 276.42,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7762d21b-e061-4c19-a9a4-793dedfcbc4f",
    x1: 891.13,
    y1: 675.02,
    x2: 891.13,
    y2: 214.93,
    gradientTransform: "matrix(-1, 0, 0, 1, 1114, 0)",
    xlinkHref: "#0bbd7947-ca61-424a-a753-fb567ef3345a"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "online") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M968.1,62.19c37.27,12.37,51.62,19.46,88.51,32.93,15.11,5.52,30.64,11.41,42.27,22.52,12.21,11.67,18.87,27.95,23.58,44.17,10.1,34.82,12.19,74.1-5.42,105.79-16.11,29-47.49,49.78-54.54,82.18-5.2,23.89,4.26,48.17,8.9,72.17a184.8,184.8,0,0,1-6.35,93.79c-9.69,28.64-28.59,56.43-57.16,66.3-33.23,11.47-69.43-3.86-104.57-2.76-39.43,1.24-75.24,23.14-105.67,48.24S739.76,681.76,706,702.07c-34.43,20.69-73.83,31.26-112.65,41.6-21.59,5.75-43.41,11.53-65.74,12.27-24.69.82-49.33-4.61-72.37-13.54-42.71-16.54-80.4-45.17-109.34-80.67-16.84-20.65-31.41-47.31-24.05-72.91,5.35-18.6,21-32,33-47.17,31.94-40.17,38.93-98.64,17.36-145.21-10.93-23.6-28.17-43.58-43.46-64.62s-29.13-44.43-31.5-70.33,9.64-54.65,33.65-64.64c29.45-12.24,71.25,3.84,90.26-21.78,7.2-9.71,8.12-22.5,10.32-34.38C443.19,77.71,503,27.15,567,26.05c49.92-.86,97,24.71,146.85,27.07C763.94,55.49,814.81,34.39,863.31,47,881.1,51.69,897.48,60.69,915.1,66s38,6.31,53.18-4.07",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 492.93,
    y: 182.79,
    width: 437.49,
    height: 30.27,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 492.93,
    y: 313.49,
    width: 437.49,
    height: 30.27,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 492.93,
    y: 449.69,
    width: 437.49,
    height: 30.27,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 104.38,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 116.76,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 159.41,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 104.38,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 116.76,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 159.41,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 104.38,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 116.76,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 159.41,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 779.09,
    y: 104.38,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 779.09,
    y: 116.76,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 779.09,
    y: 159.41,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 840.74,
    y: 397.3,
    width: 27.51,
    height: 78.42,
    transform: "translate(-163.91 403.24) rotate(-26.63)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 829.95,
    y: 412.24,
    width: 27.51,
    height: 5.5,
    transform: "translate(-155.41 396.12) rotate(-26.63)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 849.07,
    y: 450.36,
    width: 27.51,
    height: 5.5,
    transform: "translate(-170.47 408.73) rotate(-26.63)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 785.97,
    y: 236.45,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 785.97,
    y: 248.83,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 785.97,
    y: 291.48,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 827.24,
    y: 236.45,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 827.24,
    y: 248.83,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 827.24,
    y: 291.48,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 868.51,
    y: 236.45,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 868.51,
    y: 248.83,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 868.51,
    y: 291.48,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 531.46,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 572.73,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 572.73,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 572.73,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 614,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 655.27,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 696.55,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 371.27,
    width: 27.51,
    height: 78.42,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 383.65,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 737.82,
    y: 426.3,
    width: 27.51,
    height: 5.5,
    fill: "#2e81f4",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756,312.39s-8.34-2.83-12.36,4.52a13.41,13.41,0,0,0,.18,12.91c2.64,4.77,8.07,11,18.37,10.41,8.73-.47,11.64-7.13,12.43-13.33a13.7,13.7,0,0,0-18.19-14.66Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.56,330.48a13.41,13.41,0,0,1-.18-12.91c4-7.35,12.36-4.52,12.36-4.52l.43-.15a13.57,13.57,0,0,1,9.8.22,13.58,13.58,0,0,0-11.57-1.1l-.43.15s-8.34-2.83-12.36,4.52a13.41,13.41,0,0,0,.18,12.91,20,20,0,0,0,9.43,8.93A20.68,20.68,0,0,1,745.56,330.48Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.67,315.92s3.09,2.43,10.61,0",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,298.25s5.3,14.36,4.86,18.12l4.2-.44s-7.07-12.59-5.3-17.68Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,298.25s5.3,14.36,4.86,18.12l4.2-.44s-7.07-12.59-5.3-17.68Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.65,299.45s-8.35-4.27-12.08-.74-4.31,12.54-4.31,12.54S769.87,313.12,772.65,299.45Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.65,299.45s-8.35-4.27-12.08-.74-4.31,12.54-4.31,12.54S769.87,313.12,772.65,299.45Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.26,311.25s2.19-10.46,16.39-11.8",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.07,448.59s-8.34-2.83-12.36,4.52a13.41,13.41,0,0,0,.18,12.91c2.64,4.77,8.07,11,18.37,10.41,8.73-.47,11.64-7.13,12.43-13.33a13.7,13.7,0,0,0-18.19-14.66Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.66,466.68a13.41,13.41,0,0,1-.18-12.91c4-7.35,12.36-4.52,12.36-4.52l.43-.15a13.57,13.57,0,0,1,9.8.22,13.58,13.58,0,0,0-11.57-1.1l-.43.15s-8.34-2.83-12.36,4.52a13.41,13.41,0,0,0,.18,12.91,20,20,0,0,0,9.43,8.93A20.68,20.68,0,0,1,921.66,466.68Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.76,452.12s3.09,2.43,10.61,0",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.1,434.45s5.3,14.36,4.86,18.12l4.2-.44s-7.07-12.59-5.3-17.68Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.1,434.45s5.3,14.36,4.86,18.12l4.2-.44s-7.07-12.59-5.3-17.68Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.74,435.65s-8.35-4.27-12.08-.74-4.31,12.54-4.31,12.54S946,449.32,948.74,435.65Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.74,435.65s-8.35-4.27-12.08-.74-4.31,12.54-4.31,12.54S946,449.32,948.74,435.65Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.36,447.44s2.19-10.46,16.39-11.8",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.56,775S225.1,902.19,591.1,868.19s512-12,512-12,66-64-23-93-313-17-383-17-215-35-215-35Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.46,807.24s-21.72-110.07,23-185.51c18.77-31.66,27.41-68.35,23.45-104.94a285.89,285.89,0,0,0-10.46-51.23",
    transform: "translate(-58.9 -26.03)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.36,417.85c-1.21,13.13-28.49,49-28.49,49s-20.28-40.27-19.08-53.41a23.88,23.88,0,1,1,47.56,4.37Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1136,494.22c-8.15,10.37-50.57,25.68-50.57,25.68s4.86-44.83,13-55.2A23.88,23.88,0,1,1,1136,494.22Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.85,618.39c-12.27,4.84-56.61-3.36-56.61-3.36s26.83-36.24,39.1-41.08a23.88,23.88,0,1,1,17.51,44.44Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.75,710.1c-11.28,6.84-56.37,6.26-56.37,6.26s20.32-40.26,31.59-47.1a23.88,23.88,0,0,1,24.77,40.84Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.25,517.86c8.58,10,51.6,23.53,51.6,23.53s-6.74-44.59-15.32-54.6a23.88,23.88,0,1,0-36.28,31.07Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.25,625.58c11.18,7,56.28,7,56.28,7s-19.78-40.53-31-47.52a23.88,23.88,0,0,0-25.32,40.5Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M980.59,734.95c9.84,8.78,54.28,16.42,54.28,16.42s-12.64-43.28-22.49-52.07a23.88,23.88,0,1,0-31.8,35.64Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M905.94,186l-14.77-6.14,19.76-47.55,14.77,6.14ZM921,128.86a9.31,9.31,0,1,1,12.14-5.08A9.34,9.34,0,0,1,921,128.86Zm40.21,80.08-14.74-6.12,9.62-23.15c2.29-5.52,5.12-12.64-2.45-15.78s-11.35,2.31-13.92,8.51l-9.78,23.54-14.75-6.13,19.76-47.55,14.16,5.89-2.7,6.49.21.09c3.52-2.92,10-4.86,17.16-1.87,14.94,6.21,13.6,17.19,8.29,30l-10.85,26.12Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M595.58,121.14l-5.87,15v61.28h20.86v11.07h11.74l11.07-11.07h17l22.81-22.81V121.14Zm69.76,49.54-13,13H631.43L620.36,194.8V183.73H602.75V129h62.58Zm-13-26.73v22.79h-7.82V144Zm-20.86,0v22.79h-7.82V144Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M493.89,695.71l-.47-40.27v-1.18l-6.35-540.39c0-.66,0-1.31-.06-2a53.87,53.87,0,0,0-2.15-12.74c-.1-.33-.19-.65-.29-1s-.2-.61-.31-.92-.26-.77-.4-1.15-.21-.55-.31-.83-.31-.8-.47-1.2l-.33-.78c-.17-.41-.35-.81-.53-1.21l-.35-.74q-.29-.6-.59-1.2l-.37-.72q-.31-.59-.64-1.18l-.39-.7c-.23-.39-.46-.78-.69-1.16l-.41-.67c-.25-.39-.5-.78-.76-1.16L477.6,84c-.28-.41-.57-.81-.86-1.21l-.37-.51q-.63-.85-1.3-1.67A55.29,55.29,0,0,0,428.68,60.1l-274,16.12a55.49,55.49,0,0,0-18.42,4.29C96.48,92.68,58,119.1,58.92,166.86L69.23,725c.85,46.12,39.53,83,84.46,90.81a55.35,55.35,0,0,0,28.09.75l269.61-62.4a54.65,54.65,0,0,0,42.55-53.71Z",
    transform: "translate(-58.9 -26.03)",
    fill: "url(#0bbd7947-ca61-424a-a753-fb567ef3345a)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.57,173.93,73.66,726.16c.94,51.45,48.94,91.34,99.71,91.34h0L150.66,85.33l-2,.51C106.65,96.45,62.64,122.86,63.57,173.93Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#535461"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.57,173.93,73.66,726.16c.94,51.45,48.94,91.34,99.71,91.34h0L150.66,85.33l-2,.51C106.65,96.45,62.64,122.86,63.57,173.93Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M489.29,701.87A54,54,0,0,1,447.65,755L183.8,816.75a53.93,53.93,0,0,1-66.22-51.56l-.8-45.88v-.46l-2.5-141.19-7.59-430.05-.16-8.59a53.94,53.94,0,0,1,50.73-54.78L425.43,68.29a53.89,53.89,0,0,1,57,50c.09,1.05.13,2.13.14,3.21l6.21,534.69,0,2.76.45,38.25Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M489.29,701.87A54,54,0,0,1,447.65,755L183.8,816.75a53.93,53.93,0,0,1-66.22-51.56l-.8-45.88v-.46l-2.5-141.19-7.59-430.05-.16-8.59a53.94,53.94,0,0,1,50.73-54.78L425.43,68.29a53.89,53.89,0,0,1,57,50c.09,1.05.13,2.13.14,3.21l6.21,534.69,0,2.76.45,38.25Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M489.24,697.2,249,722.77,230.6,109.67,470.82,88.53a53.65,53.65,0,0,1,11.74,33Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "429.89 632.92 57.87 692.82 55.37 551.64 185.24 534.27 429.89 632.92",
    fill: "#2e81f4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "429.89 632.92 57.87 692.82 55.37 551.64 185.24 534.27 429.89 632.92",
    fill: "#fff",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M489.29,701.87A54,54,0,0,1,447.65,755L183.8,816.75a53.93,53.93,0,0,1-66.22-51.56l-.8-45.88,372-63.13,0,2.76.45,38.25Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#535461"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M482.41,118.29,106.68,147.61l-.16-8.59a53.94,53.94,0,0,1,50.73-54.78L425.43,68.29a53.89,53.89,0,0,1,57,50Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#535461"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 262.48,
    cy: 711.22,
    r: 26.31,
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.69 78.69 226.96 81.01 226.96 78.38 271.69 76.06 271.69 78.69",
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 17.66,
    y: 180.71,
    width: 16,
    height: 51.88,
    rx: 8,
    ry: 8,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.12,
    cy: 81.01,
    r: 2.63,
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.24,288.67a11.36,11.36,0,0,0,6.7,6.25c1.33.43,2.73.58,4.08.91,6.45,1.61,11,7.19,16.9,10.27a3.25,3.25,0,0,0,1.56.48l.2,0a1.92,1.92,0,0,0,.37,0,3.13,3.13,0,0,0,1.65-.69l.26-.2a19.78,19.78,0,0,1,.29,8c-2.34,0-17.49.93-15.42,18.83,2.25,19.38,24.72,46.52,24.72,46.52s15.73,16.06,10.67,70.89l-.56,26.58s6-.91,13.75-1.82q.27.53.55,1a41.39,41.39,0,0,0,8.3,10.26l12.79,30.39s1.1,2,2.72,5.1c.15,6.44-3.85,12.07-3.85,12.07-24.72,7.2-34.83,33.23-34.83,33.23s-14,8.36-17,17.67c-5.89,4.77-5.49,17.78-5.49,17.78s20.79,11.08,36,17.17a25,25,0,0,0,5.47,1.5l-3.38,7h0c-3.52,1.27-3.78,18.67-3.78,18.67s37.08,26.58,48.31,28.25,20.79-6.09,9-11.63c-9.5-4.46-20.1-21.5-23.86-28,4.7-6.45,19.54-27.35,20.49-35.73C252,589.5,266,581.19,266,581.19c20.22-21.6,6.74-47.08,5.06-60.37,0-.25-.07-.53-.12-.83a145.4,145.4,0,0,0-4.75-17c2.21-13.94,4-35.71,5-50.08,4.46,1.44,8.83,3.13,8.83,3.13,8.2-16.65-19.66-85.2-27.68-104.2,4.68-1.55,12.74-4,24.31-6.56,19.66-4.43,20.79-14.4,20.79-14.4l15.17-41c-1.29.58-3.27.55-5.59.15,0-.34,0-.71,0-1.11.12-3.89.49-10.1,1.63-11.23,0,0-3.73,0-8.26-.4l0-.55,2-25.07s-2.81-27.69-12.36-23.82c-7.67,3.11-6.64,28-5.94,37.69a16.81,16.81,0,0,0,2.13,7l.64,1.14.44.78a9.44,9.44,0,0,1-1.21-.69v8.58c-1.06-.51-1.69-.82-1.69-.82.56,9.42-11.24,41-11.24,41s-20.79-2.22-27.53,2.22c-4.94,3.25-11.4-3-14.49-6.61l14.49-31.6a41.43,41.43,0,0,1-5.17-1.26c.06-.38.14-.79.21-1.21.74-4,2.06-9.56,3.84-10.26a63,63,0,0,0-8-3.66c.06-.32.13-.66.21-1,1.05-5.54,2.7-17.51-.65-25.77-4.49-11.08-6.18-32.68-14.61-27.69-6.69,4-7,27.79-6.85,37.46a16.61,16.61,0,0,0,1.92,7.51l3.25,6.15.45.85-.45.08v7.57c-1.42-.9-2.25-1.47-2.25-1.47-.28,10.65-7.33,24.84-14.22,36.26l-3.5-2.52-.86-.62a2.14,2.14,0,0,1,0-.33s-1.44-.41-3.72-.87c-2.83-5.37-4.41-11.85-5.29-17.23-.09-.56-.17-1.11-.25-1.64a22.35,22.35,0,0,0,2-9.17,22.81,22.81,0,0,0-19.26-22.4c.69-.77,1-1,1.2-1h.15a4.17,4.17,0,0,0,2.54-.68c1.78-.87,3.79-2.16,3.78-4.11,0-1.43-1.14-2.61-2.34-3.42-2.9-1.94-3-5.29-5.68-5a3.58,3.58,0,0,0-1.53.2c-2.47.81-4.62,2.36-7,3.34a16.64,16.64,0,0,1-5.28,1.2,21.85,21.85,0,0,0-3.46.27,10.16,10.16,0,0,0-2.61,1.06c-5.08,2.77-10.93,7-12.56,12.47-1.53,5.14.59,11.81-3.35,15.51a14.5,14.5,0,0,0-2,1.89,6.56,6.56,0,0,0-1,2.52A15.11,15.11,0,0,0,134.24,288.67ZM237,555c.21,2.65-.29,4.53-1.84,5.14-8.43,3.32-18,33.78-18,33.78l-6.39,13.19a170,170,0,0,1-14.53-12.29l.69-4.77s18-13.29,19.1-17.17C216.92,569.75,231.45,559,237,555Z",
    transform: "translate(-58.9 -26.03)",
    fill: "url(#7762d21b-e061-4c19-a9a4-793dedfcbc4f)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,348.37s38.2,88.42,28.93,107.52c0,0-15.28-6-17.47-4.91s-24-114.07-24-114.07Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#c4c8e2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,348.37s38.2,88.42,28.93,107.52c0,0-15.28-6-17.47-4.91s-24-114.07-24-114.07Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.76,630s13.1,24.56,24.56,30,2.18,13.1-8.73,11.46-46.94-27.84-46.94-27.84.25-17.15,3.67-18.4S228.76,630,228.76,630Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#4c495a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.37,590.15s18.56,18.56,26.74,20.19-7.1,12.55-21.83,6.55S164.35,600,164.35,600s-.55-17.47,8.73-19.1S194.37,590.15,194.37,590.15Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#4c495a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M270.78,438.42S267,505,262,514.29s-23.47,37.66-23.47,37.66-21.29,15.28-22.38,19.1S197.65,588,197.65,588l-1.09,7.64s-28.93-1.64-27.29-11.46S186.19,565,186.19,565,196,539.39,220,532.3c0,0,7.64-10.92,1.09-19.65,0,0-16.37-40.93-25.65-45.85s3.82-33.29,3.82-33.29Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#5f5d7e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M270.78,438.42S267,505,262,514.29s-23.47,37.66-23.47,37.66-21.29,15.28-22.38,19.1S197.65,588,197.65,588l-1.09,7.64s-28.93-1.64-27.29-11.46S186.19,565,186.19,565,196,539.39,220,532.3c0,0,7.64-10.92,1.09-19.65,0,0-16.37-40.93-25.65-45.85s3.82-33.29,3.82-33.29Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.05
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.3,591.79l-17.47,36.57c2.73,9.28,28.93,6,28.93,6S249,607.07,250,597.25s14.74-18,14.74-18c19.65-21.29,6.55-46.39,4.91-59.49,0-.25-.07-.52-.12-.81-1.45-8.78-10.28-34.06-17.15-53-4.63-12.75-8.38-22.62-8.38-22.62s-36.57,1.64-44.21,14.74c-3.5,6-1.93,12.24.79,17.25a40.65,40.65,0,0,0,8.07,10.11l12.43,30s21.83,39.84,13.64,43.12S217.3,591.79,217.3,591.79Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#5f5d7e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.47,268.17a16.74,16.74,0,0,0,2.07,6.95l.62,1.12,3.08,5.55h9.82l.21-2.58,2-24.71s-2.73-27.29-12-23.47C280.8,234.09,281.79,258.61,282.47,268.17Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#fdc2cc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M285.17,276.24l3.08,5.55h9.82l.21-2.58C293.71,278.8,288.26,278,285.17,276.24Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M284.43,276.33v12.55l20.19,5.46s0-1.3.05-3.13c.11-3.83.47-10,1.58-11.06C306.26,280.15,289.88,280.15,284.43,276.33Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#eaeaf3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M284.43,283.69v5.19l20.19,5.46s0-1.3.05-3.13C298,290,288.25,285.54,284.43,283.69Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.64,304.4c4,11.51-1.2,16.68-1.2,16.68s49.12,3.27,37.11-5.46c-7-5.1-10.12-16.35-11.48-24.82A84.65,84.65,0,0,1,190,280.15s-39.25-.58-31.11,10.37A52.55,52.55,0,0,1,166.64,304.4Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#fdc2cc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M158.9,290.52c4,5.38,5.31,6.17,6.65,10.06a21.94,21.94,0,0,0,3.72.31c9.36,0,18.47-1.93,21.81-10.09A84.65,84.65,0,0,1,190,280.15S150.75,279.57,158.9,290.52Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.45,
    cy: 254.12,
    r: 22.38,
    fill: "#fdc2cc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M282.79,284s21.29,10.92,27.29,8.19l-14.74,40.39s-1.09,9.82-20.19,14.19-28.38,8.19-28.38,8.19l-35.48-42,18,4.91s9.28,13.1,15.83,8.73,26.74-2.18,26.74-2.18S283.34,293.25,282.79,284Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#c4c8e2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M282.79,284s21.29,10.92,27.29,8.19l-14.74,40.39s-1.09,9.82-20.19,14.19-28.38,8.19-28.38,8.19l-35.48-42,18,4.91s9.28,13.1,15.83,8.73,26.74-2.18,26.74-2.18S283.34,293.25,282.79,284Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.05
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M199.83,309.73s-28.85-8.25-31.89,7.08c0,0,13.33-6.5,32.44,5,1.43.86,2.83,1.78,4.2,2.74,16.81,11.78,28.55,30,33.27,50.71L250,428.67,251.13,443s17.47,3.45,20.74-1.72,1.09-22.41-3.82-28.15S255.5,382.7,255.5,382.7l-4.78-14.33A95.85,95.85,0,0,0,232,335.59h0l-1.15-1.39a71.66,71.66,0,0,0-26.61-19.9C201.47,313.07,199.45,311.54,199.83,309.73Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.83,308.64s-28.85-8.25-31.89,7.08c0,0,13.33-6.5,32.44,5,1.43.86,2.83,1.78,4.2,2.74,16.81,11.78,28.55,30,33.27,50.71L250,427.57l1.09,14.36s17.47,3.45,20.74-1.72,1.09-22.41-3.82-28.15-12.55-30.45-12.55-30.45l-4.78-14.33A95.85,95.85,0,0,0,232,334.49h0l-1.15-1.39a71.66,71.66,0,0,0-26.61-19.9C201.47,312,199.45,310.45,199.83,308.64Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#eaeaf3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M272.39,418.66l-.24,9.4-7.64-4.91s-13.61-49.53-23.2-63c-1.13-1.59-1.68-4-2.73-4.37l-39-37.66v-8.73s19.92,14.74,21.56,17.47c.7,1.16,11.16,6.88,17.47,15.83a197.85,197.85,0,0,1,15,25.92L266.69,398Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M199.56,308.8v8.46l39.57,37.93c1.05.4,1.6,2.78,2.73,4.37,9.59,13.51,23.2,63,23.2,63l7.64,4.91.24-9.4-5.7-20.62L254.14,368a197.8,197.8,0,0,0-15-25.92c-6.3-9-16.77-14.67-17.47-15.83-1.41-2.35-16.8-13.62-21-16.69Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#d39999"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 163.19,
    y: 153.16,
    width: 78,
    height: 78,
    rx: 11.17,
    ry: 11.17,
    fill: "#2e81f4"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 163.19,
    y: 153.16,
    width: 78,
    height: 78,
    rx: 11.17,
    ry: 11.17,
    fill: "#fff",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M261.1,201.84a16.36,16.36,0,1,0,16.36,16.36A16.33,16.33,0,0,0,261.1,201.84Zm0,27a10.63,10.63,0,1,1,10.63-10.63,10.65,10.65,0,0,1-10.63,10.63Zm20.84-27.66a3.82,3.82,0,1,1-3.82-3.82A3.81,3.81,0,0,1,281.95,201.17ZM292.78,205c-.24-5.11-1.41-9.64-5.15-13.37s-8.26-4.9-13.37-5.15c-5.27-.3-21.06-.3-26.32,0-5.1.24-9.62,1.41-13.37,5.14s-4.9,8.26-5.15,13.37c-.3,5.27-.3,21.06,0,26.32.24,5.11,1.41,9.64,5.15,13.37s8.26,4.9,13.37,5.15c5.27.3,21.06.3,26.32,0,5.11-.24,9.64-1.41,13.37-5.15s4.9-8.26,5.15-13.37c.3-5.27.3-21,0-26.31ZM286,237a10.77,10.77,0,0,1-6.06,6.06c-4.2,1.67-14.17,1.28-18.81,1.28s-14.62.37-18.81-1.28a10.77,10.77,0,0,1-6.06-6.06c-1.67-4.2-1.28-14.17-1.28-18.81s-.37-14.62,1.28-18.81a10.77,10.77,0,0,1,6.06-6.06c4.2-1.67,14.17-1.28,18.81-1.28s14.62-.37,18.81,1.28a10.77,10.77,0,0,1,6.06,6.06c1.67,4.2,1.28,14.17,1.28,18.81S287.64,232.81,286,237Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M177.81,256.39c1.73-.85,3.68-2.13,3.67-4.05A4.45,4.45,0,0,0,179.2,249c-3.12-2.12-2.88-6-6.46-4.77-2.4.8-4.49,2.32-6.83,3.29a16,16,0,0,1-5.13,1.19,20.93,20.93,0,0,0-3.37.27,9.79,9.79,0,0,0-2.54,1,21.92,21.92,0,0,0-10.31,12.86c-1.48,5.07-1.33,11.07-5.15,14.71a14.19,14.19,0,0,0-1.9,1.86,6.51,6.51,0,0,0-1,2.49,15.09,15.09,0,0,0,.75,9.06,11.1,11.1,0,0,0,6.51,6.16c1.29.42,2.65.57,4,.9,6.27,1.58,10.71,7.08,16.42,10.12a3.13,3.13,0,0,0,1.52.48,3,3,0,0,0,1.6-.68c2.21-1.58,4-4,4-6.74a13.63,13.63,0,0,0-1.46-4.86,47.09,47.09,0,0,1-2.73-8.79,4.29,4.29,0,0,1-.06-2.13c.41-1.32,1.88-1.94,2.9-2.88,1.94-1.8,2.17-4.84,1.45-7.38s-2.21-4.78-3.33-7.17a5.65,5.65,0,0,1-.66-2.33c0-3.19,4.31-4.92,6.13-7C176,255.78,174.44,258.06,177.81,256.39Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M177.26,256.39c1.73-.85,3.68-2.13,3.67-4.05a4.45,4.45,0,0,0-2.28-3.37c-3.12-2.12-2.88-6-6.46-4.77-2.4.8-4.49,2.32-6.83,3.29a16,16,0,0,1-5.13,1.19c-1.13.07-4.77-1.65-5.87-1.4a9.79,9.79,0,0,0-2.54,1,21.92,21.92,0,0,0-10.31,12.86c-1.48,5.07-.45,11.4-4.27,15-.64.61.23,2.47-.29,3.19a6.51,6.51,0,0,0-1,2.49,15.09,15.09,0,0,0,.75,9.06,11.1,11.1,0,0,0,6.51,6.16c1.29.42,2.65.57,4,.9,6.27,1.58,10.71,7.08,16.42,10.12a3.13,3.13,0,0,0,1.52.48,3,3,0,0,0,1.6-.68c2.21-1.58,4-4,4-6.74a13.63,13.63,0,0,0-1.46-4.86,47.09,47.09,0,0,1-2.73-8.79,4.29,4.29,0,0,1-.06-2.13c.41-1.32,1.88-1.94,2.9-2.88,1.94-1.8,2.17-4.84,1.45-7.38s-2.21-4.78-3.33-7.17a5.65,5.65,0,0,1-.66-2.33c0-3.19,4.31-4.92,6.13-7C175.45,255.78,173.89,258.06,177.26,256.39Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#865a61"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M200.62,475.32c10-1.18,22.6-2.34,28.14-1.42,8.91,1.48,21.41-6.46,23.66-7.95-4.63-12.75-8.38-22.62-8.38-22.62s-36.57,1.64-44.21,14.74C196.33,464.07,197.9,470.31,200.62,475.32Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M152.89,334.18c2.18,19.1,24,45.85,24,45.85s15.28,15.83,10.37,69.86l-.55,26.2s32.2-4.91,42-3.27,24-8.19,24-8.19,5.46-94.42-18-114.07a138.64,138.64,0,0,0-9.43-12.83c-6.3-7.63-14.87-16.22-22.88-18.34a14.32,14.32,0,0,0-3.16-.49s-24.56-13.64-31.11-3.27C168.17,315.62,150.71,315.08,152.89,334.18Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#c4c8e2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M252.5,436s-8.73-3.82-23.47-2.73-41-12-41-12",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M236.67,557.68s-.55,1.64,6.55,3.82,9.28,4.37,9.28,4.37",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.05
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M215,255.94a16.56,16.56,0,0,0,1.87,7.4L220,269.4l2.18,4.2,13.64,1.09s.28-1.12.63-3c1-5.46,2.63-17.25-.63-25.4-4.37-10.92-6-32.2-14.19-27.29C215.17,222.92,214.86,246.41,215,255.94Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#fdc2cc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M220,269.23v.17l2.18,4.2,13.64,1.09s.28-1.12.63-3C231.6,269.81,225.2,268.08,220,269.23Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M220,270.32v9.82l19.65,10.37s.22-1.78.64-4.08c.71-3.95,2-9.43,3.73-10.11C244,276.33,229.85,268.14,220,270.32Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#eaeaf3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M166.89,359.53a23.12,23.12,0,0,0,17.65,5.65c34.55-3.51,35.49-15.72,35.49-15.72l5.31-11.74c-6.3-7.63-14.87-16.22-22.88-18.34-5.73,9.23-10.8,15.89-10.8,15.89s-25.65-19.65-33.29-1.09C153.9,345,160.55,353.94,166.89,359.53Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.05
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220,276.34v3.81l19.65,10.37s.22-1.78.64-4.08C231.85,283.72,223.47,278.58,220,276.34Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M217.84,276.33s14.74,10.37,27.29,12.55l-25.65,56.76s-.94,12.21-35.49,15.72a23.13,23.13,0,0,1-17.65-5.65c-6.33-5.6-13-14.55-8.53-25.35,7.64-18.56,33.29,1.09,33.29,1.09S217.3,297.07,217.84,276.33Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#c4c8e2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M428.2,189c0,.68,0,1.35,0,2,0,20.59-15.67,44.32-44.32,44.32a44,44,0,0,1-23.92-7,32.22,32.22,0,0,0,3.76.19,31.2,31.2,0,0,0,19.34-6.65,15.6,15.6,0,0,1-14.56-10.8,19.64,19.64,0,0,0,2.94.24,16.47,16.47,0,0,0,4.1-.53,15.58,15.58,0,0,1-12.49-15.29v-.19a15.69,15.69,0,0,0,7,2,15.6,15.6,0,0,1-4.82-20.83,44.28,44.28,0,0,0,32.12,16.3,17.58,17.58,0,0,1-.39-3.57,15.59,15.59,0,0,1,27-10.66,30.67,30.67,0,0,0,9.89-3.76,15.53,15.53,0,0,1-6.85,8.58,31.23,31.23,0,0,0,9-2.41A33.48,33.48,0,0,1,428.2,189Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M369.64,351.15v58.71a3.64,3.64,0,0,1-3.64,3.64H349.17V387.95h8.57L359,378h-9.87v-6.36c0-2.89.8-4.85,4.94-4.85h5.27v-8.91a70.91,70.91,0,0,0-7.69-.4c-7.6,0-12.82,4.64-12.82,13.17V378h-8.6v10h8.6v25.56H307.28a3.65,3.65,0,0,1-3.64-3.64V351.15a3.65,3.65,0,0,1,3.64-3.64H366A3.65,3.65,0,0,1,369.64,351.15Z",
    transform: "translate(-58.9 -26.03)",
    opacity: 0.2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M680.72,272.9a13.31,13.31,0,0,0-9.89-8.88c-8.38-1.76-41.45.11-41.45.11s-33.08,1.87-41.2,4.56a13.31,13.31,0,0,0-8.82,9.94c-1.74,8.43-.76,25.75-.76,25.75s1,17.32,3.66,25.5a13.11,13.11,0,0,0,9.88,8.73c8.38,1.76,41.45-.11,41.45-.11s33.08-1.87,41.2-4.56a13.11,13.11,0,0,0,8.83-9.79c1.74-8.43.76-25.75.76-25.75S683.4,281.08,680.72,272.9Zm-59.16,44.84-1.78-31.46,28.54,14.16-26.76,17.29Z",
    transform: "translate(-58.9 -26.03)",
    fill: "#2e81f4",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookClone);
export default __webpack_public_path__ + "static/media/facebook-clone.d11b426d8267f22410a7bb30dd70fd55.svg";
export { ForwardRef as ReactComponent };